const env = {
    API_URL: 'http://api.angha.me/gateway.php',
    DASHBOARD_API_URL: 'https://dashapi.anghami.com/gateway.php',
    KOUSA_API_URL: 'https://koussa.anghami.com',
    RECAPTCHA_KEY: '6LcsnakUAAAAAOi6tEpMkI3IQmHJ03hEEq1zEB9v',
    CREATORS_RECAPTCHA_KEY: '6LeRHYckAAAAAAxw5KeRyD35WzlxKCVBO4bZyAnN',
    RECAPTCHA_CDN_URL: 'https://cdnweb.anghami.com/web/recaptcha_ang.js',
    RECAPTCHA_CDN_URL_ALT: 'https://webcdn.anghami.com/web/recaptcha_ang.js',
    ANG_EN_TOKEN: '-Jlfi6:CFND;bpKs;svX]dj@',
    SUP_SEC_KEY: '34%i7ateMyImcreept24fjf#ang.',
    SODIUM_CDN_URL: 'https://cdnweb.anghami.com/web/assets/vendor/sodiumjs/sodium.js',
    SODIUM_CDN_URL_ALT: 'https://webcdn.anghami.com/web/assets/vendor/sodiumjs/sodium.js',
    TEXT_ENCODER_POLYFILL: 'https://cdnweb.anghami.com/web/assets/vendor/text-encoding-polyfill@0.6.7.min.js',
    TEXT_ENCODER_POLYFILL_ALT: 'https://webcdn.anghami.com/web/assets/vendor/text-encoding-polyfill@0.6.7.min.js',
    FFLATE_CDN_URL: 'https://cdnweb.anghami.com/web/assets/vendor/fflate.js',
    FFLATE_CDN_URL_ALT: 'https://webcdn.anghami.com/web/assets/vendor/fflate.js'
};

export { env as default };
//# sourceMappingURL=env.js.map
